import React from 'react';
import StartInterviewLayout from '../../components/layout/StartInterviewLayout';

const WebApi = () => {
  return (
    <StartInterviewLayout type="webapi"/>
  )
}

export default WebApi;